<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px; padding-top: 16px"
      >
        <span class="headline mb-0">{{ $t('B0400.titles[0]') }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          @click="search"
          class="btn-search"
          v-permit.SHARP_SA_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn to="/B0401/new" v-permit.SHARP_SA_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_SA_UPDATE
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1"
          @click="toNew"
          v-permit.SHARP_SA_CLONE
          >{{ $t('app.buttons.toNew') }}</v-btn
        >
        <v-btn @click="exportCsv" v-permit.SHARP_SA_CSV_DOWNLOAD>{{
          $t('app.buttons.csvExport')
        }}</v-btn>
        <v-btn @click="combineSa" v-show="true">合併</v-btn>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
        <!-- <v-btn @click="unionBu" v-show="true">SA分组回退</v-btn> -->
        <!-- <a @click="$watchVideo('B0400-01')" href="#">{{$t('app.buttons.videoTutorial')}}</a> -->
        <v-spacer />
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs3
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.blNo')"
                clearable
                v-model="query.blNo"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="D/O No" v-model="query.doNo" />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="Master B/L No"
                v-model="query.masterBlNo"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="House B/L No"
                v-model="query.houseBlNo"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="Invoice No"
                v-model="query.invNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.shippingAdvice.requestDate')"
                    :max="query.requestDateTo"
                    v-model="query.requestDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.requestDateFrom"
                    v-model="query.requestDateTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.shippingAdvice.blIssueDate')"
                    :max="query.blIssueDateTo"
                    v-model="query.blIssueDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.blIssueDateFrom"
                    v-model="query.blIssueDateTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                url="ports/kv"
                v-model="query.loadingPortCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-select
                :label="$t('app.labels.transportMode')"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>

            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.forwarder')"
                url="companies/forwarders/kv"
                v-model="query.forwarderId"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.shipName')"
                clearable
                v-model="query.shipName"
              />
            </v-flex>

            <v-flex xs3>
              <v-select
                :items="status"
                :multiple="false"
                clearable
                item-text="value"
                item-value="value"
                label="ステータス"
                v-model="query.status"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.etd')"
                    :max="query.etdTo"
                    v-model="query.etdFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etdFrom"
                    v-model="query.etdTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.eta')"
                    :max="query.etaTo"
                    v-model="query.etaFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etaFrom"
                    v-model="query.etaTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="elevation-1"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{ props.item.companyName }}
              </td>
              <td>
                {{ props.item.headquarterCode }}:{{
                  props.item.headquarterName
                }}
              </td>
              <td>
                {{ props.item.partnerCode }} - {{ props.item.partnerName }}
              </td>
              <td>
                {{ props.item.forwarderCode }} - {{ props.item.forwarderName }}
              </td>
              <td>{{ props.item.blNo }}</td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.status }}</td>
              <td
                :class="{
                  redFont:
                    props.item &&
                    props.item.loadingPortCode &&
                    props.item.loadingPortCode.length > 3,
                }"
              >
                {{ props.item.loadingPortCode }} -
                {{ props.item.loadingPortName }}
              </td>
              <td
                :class="{
                  redFont:
                    props.item &&
                    props.item.dischargePortCode &&
                    props.item.dischargePortCode.length > 3,
                }"
              >
                {{ props.item.dischargePortCode }} -
                {{ props.item.dischargePortName }}
              </td>
              <td>{{ props.item.requestDate }}</td>
              <td>{{ props.item.blIssueDate }}</td>
              <td>{{ props.item.exportCustomsClearanceDate }}</td>
              <td>{{ props.item.shipName }}</td>
              <td>{{ props.item.volNo }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.transportModeCode }}</td>
              <td>{{ props.item.sendDate }}</td>
              <td>{{ props.item.createDate }}</td>
              <td>{{ props.item.updateDate }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <mock-dialog ref="mockDlg"></mock-dialog>
  </v-container>
</template>

<script>
import MockDialog from './MockDialog'
export default {
  components: {
    MockDialog,
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  data() {
    return {
      valid: false,
      errors: {
        NOT_ALL_FORMAL: '合併対象本SAではないため、合併できません。',
        CAN_NOT_COMBINE:
          '合併対象本SAの「DONo/MasterBL/HouseBL/ステータス」が不一致のため、合併できません。',
      },
      selected: [],
      query: {
        username: this.$route.params.username,
      },
      results: [],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
      headers: [
        {
          text: this.$t('app.labels.company.name'),
          value: 'companyName',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.bu.name'),
          value: 'buName',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.partner'),
          value: 'partnerCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.forwarder'),
          value: 'forwarderCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.blNo'),
          value: 'blNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'doNo',
          value: 'doNo',
          sortable: false,
        },

        {
          text: this.$t('app.labels.status'),
          value: 'status',
          sortable: false,
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPortCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePortCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.shippingAdvice.requestDate'),
          value: 'requestDate',
          sortable: false,
        },
        {
          text: this.$t('app.labels.shippingAdvice.blIssueDate'),
          value: 'blIssueDate',
          sortable: false,
        },
        {
          text: this.$t('app.labels.shippingAdvice.exportCustomsClearanceDate'),
          value: 'exportCustomsClearanceDate',
          sortable: false,
        },
        {
          text: this.$t('app.labels.shipName'),
          value: 'shipName',
          sortable: false,
        },
        {
          text: this.$t('app.labels.volNo'),
          value: 'volNo',
          sortable: false,
        },
        {
          text: this.$t('app.labels.etd'),
          value: 'etd',
          sortable: false,
        },
        {
          text: this.$t('app.labels.eta'),
          value: 'eta',
          sortable: false,
        },
        {
          text: this.$t('app.labels.transportMode'),
          value: 'transportModeCode',
          sortable: false,
        },
        {
          text: 'SAP送信時間',
          value: 'sendDate',
          sortable: false,
        },
        {
          text: '创建时间',
          value: 'createDate',
          sortable: false,
        },
        {
          text: '更新时间',
          value: 'updateDate',
          sortable: false,
        },
        {
          text: '更新者',
          value: 'updatedBy',
          sortable: false,
        },
      ],
      status: [
        {
          key: 1,
          value: 'SA一時保存-SJL',
          sortable: false,
        },
        {
          key: 2,
          value: 'SA一時保存-海',
          sortable: false,
        },
        {
          key: 3,
          value: 'SA一時保存',
          sortable: false,
        },
        {
          key: 4,
          value: 'SJL送信済',
          sortable: false,
        },
        {
          key: 8,
          value: '海外取引先登録済',
          sortable: false,
        },
        {
          key: 5,
          value: 'SA登録済',
          sortable: false,
        },
        {
          key: 6,
          value: '指示Mail送信済',
          sortable: false,
        },
        {
          key: 7,
          value: '指示Mail送信解除',
          sortable: false,
        },
        {
          key: 8,
          value: '凍結後SA取消申請済み',
          sortable: false,
        },
        {
          key: 9,
          value: '凍結後SA一時保存戻し申請済み',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    unionBu() {
      this.$http
        .put(`/shipping-advices/${this.selected[0].id}/union-bu`)
        .then(() => {
          this.$message('', 'ok')
          this.load()
        })
    },
    combineSa() {
      var ids = this.selected.map((s) => s.id).join(',')
      this.$http
        .put(`/shipping-advices/combine-sa`, {
          ids: ids,
        })
        .then(() => {
          this.$message('', '合併完了いたしました。')
          this.load()
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    mock() {
      this.$http.get(`/shipping-advices/${this.selected[0].id}`).then((res) => {
        this.$refs.mockDlg.popup(res.data)
      })
    },
    toNew() {
      this.$http.get(`/shipping-advices/${this.selected[0].id}`).then((res) => {
        let newSa = {
          packages: [],
          partnerId: res.data.partnerId,
          masterBlNo: res.data.masterBlNo,
          houseBlNo: res.data.houseBlNo,
          stackTypeId: res.data.stackTypeId,
          requestDate: res.data.requestDate,
          blIssueDate: res.data.blIssueDate,
          volNo: res.data.volNo,
          shipName: res.data.shipName,
          loadingPortCode: res.data.loadingPortCode,
          etd: res.data.etd,
          transportModeId: res.data.transportModeId,
          dischargePortCode: res.data.dischargePortCode,
          currencyCode: res.data.currencyCode,
          eta: res.data.eta,
          exportCustomsClearanceDate: res.data.exportCustomsClearanceDate,
          forwarderId: res.data.forwarderId,
          siNo: res.data.siNo,
          customsDirectorId: res.data.customsDirectorId,
          commodityTypeId: res.data.commodityTypeId,
        }
        this.$router.push({
          name: 'NewB0401',
          params: {
            sa: newSa,
          },
        })
      })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'meta.updateAt,desc',
        },
      }
    },
    edit() {
      this.$router.push({
        name: 'EditB0401',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    load() {
      this.query.username = this.$route.params.username
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/shipping-advices?view=B0400', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    exportCsv() {
      // this.$http
      //   .get('shipping-advices', {
      //     params: {
      //       ...this.query,
      //       page: 0,
      //       size: 1000,
      //       sort: [
      //         this.pagination.sortBy,
      //         this.pagination.descending ? 'desc' : 'asc'
      //       ].join(',')
      //     }
      //   })
      //   .then(res => {
      let headers = [
        'partnerName',
        'forwarderName',
        'blNo',
        'status',
        'loadingPortName',
        'dischargePortName',
        'requestDate',
        'blIssueDate',
        'exportCustomsClearanceDate',
        'shipName',
        'volNo',
        'etd',
        'eta',
        'transportModeCode',
        'headquarterCode',
        'headquarterName',
        'totalGW',
        'totalM3',
      ]
      let showHeaders = [
        this.$t('app.labels.partner'),
        this.$t('app.labels.forwarder'),
        this.$t('app.labels.blNo'),
        this.$t('app.labels.status'),
        this.$t('app.labels.loadingPort'),
        this.$t('app.labels.dischargePort'),
        this.$t('app.labels.shippingAdvice.requestDate'),
        this.$t('app.labels.shippingAdvice.blIssueDate'),
        this.$t('app.labels.shippingAdvice.exportCustomsClearanceDate'),
        this.$t('app.labels.shipName'),
        this.$t('app.labels.volNo'),
        this.$t('app.labels.etd'),
        this.$t('app.labels.eta'),
        this.$t('app.labels.transportMode'),
        '事業本部Code',
        '事業本部Name',
        'GW',
        'M3',
      ]
      this.$exportTable(this.selected, headers, showHeaders, 'shipping-advice')
      // })
    },
  },
  mounted() {
    this.$loadParams()
    //this.search()
  },
  computed: {
    // editable() {
    //   return this.selected.map(s => s.status).filter(s => s == '処理待ち')
    //     .length < this.selected.length
    //     ? false
    //     : true
    // }
  },
}
</script>
<style scoped>
.redFont {
  color: red;
}
</style>
